import { render } from "./DisplayHorizontalBarChart.vue?vue&type=template&id=279f86dc"
import script from "./DisplayHorizontalBarChart.vue?vue&type=script&lang=js"
export * from "./DisplayHorizontalBarChart.vue?vue&type=script&lang=js"

import "./DisplayHorizontalBarChart.vue?vue&type=style&index=0&id=279f86dc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__